import "./Hero.scss";

import Button from "../../components/shared/Button";
import { ArrowRight } from "iconsax-react";
import Logo from "../../assets/images/header-logo.svg";
import FogComponent from "../../components/FogComponent";
import ScrollDown from "../../components/shared/ScrollDown";
import { useEffect, useState } from "react";

export default function Hero() {
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			// Check if user has scrolled more than a small threshold (e.g., 10px)
			if (window.scrollY > 50) {
				setIsScrolled(true);
			} else {
				setIsScrolled(false);
			}
		};

		// Add scroll event listener
		window.addEventListener("scroll", handleScroll);

		// Cleanup listener on component unmount
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []); // Empty dependency array means this runs once on mount

	return (
		<>
			<div className="hero">
				<FogComponent />

				<ScrollDown
					className={`hero-scroll-down ${isScrolled ? "hidden" : ""}`}
				/>

				<div className="hero-content-wrapper content-wrapper-lg">
					<div className="hero-content">
						<h1 className="hero-title" data-aos="fade-up">
							STEALTHY, SECURE AND EVOLVING
							<span className="hero-brand">
								<img
									src={Logo}
									alt="GATR Logo"
									className="brand-logo"
								/>
								GATR
							</span>
						</h1>

						<p
							className="hero-description"
							data-aos="fade-up"
							data-aos-delay="100"
						>
							Gatr pioneers AI-driven privacy, setting a new
							standard for&nbsp;
							<span className="highlight">
								untraceable and secure transactions.
							</span>
						</p>

						<div
							className="hero-btns"
							data-aos="fade-up"
							data-aos-delay="200"
						>
							<Button className="hero-btn" href="https://atlas-20.gitbook.io/gatr/">
								Get Started
								<ArrowRight
									className="btn-icon"
									size="19"
									color="#000000"
								/>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
